var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',{staticClass:"card-cover-image",style:(_vm.bgStyle)},[_c('svg',{attrs:{"version":"1.1","xmlns":"http://www.w3.org/2000/svg"}},[_c('filter',{attrs:{"id":"blur"}},[_c('feGaussianBlur',{attrs:{"stdDeviation":"12"}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }